var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-tab",class:{'question-tab--active': _vm.isActive}},[_c('div',{staticClass:"question-tab__indicator"}),_c('div',{staticClass:"question-tab__textarea"},[_vm._t("text"),_vm._t("options")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }